<p-dialog
  header="Set currency"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: 'min(28rem, 96vw)' }"
  [breakpoints]="{ '575px': '96vw' }"
  appendTo="body"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [closable]="!isSaving()"
  [closeOnEscape]="!isSaving()"
>
  <div class="flex flex-col gap-4">
    <p class="m-0 text-sm text-surface-switch-600">
      Choose the customer (display) currency. The suggested exchange rate is
      based on European Central Bank reference rates against your organisation
      base currency
      <span class="font-medium text-surface-switch-800">{{
        baseCurrencyCode()
      }}</span
      >. You can edit the rate before saving.
    </p>

    @if (rateDate()) {
      <p class="m-0 text-xs text-surface-switch-500">
        ECB rates as of {{ rateDate() }}
      </p>
    }

    @if (isLoading()) {
      <p class="m-0 text-sm text-surface-switch-600">Loading exchange rates…</p>
    } @else if (loadError()) {
      <p class="m-0 text-sm text-red-600" role="alert">{{ loadError() }}</p>
    } @else {
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium" for="currency-exchange-select"
          >Display currency</label
        >
        <p-select
          inputId="currency-exchange-select"
          [options]="currencyOptions()"
          [ngModel]="selectedCurrency()"
          (ngModelChange)="onCurrencyChange($event)"
          optionLabel="name"
          [filter]="true"
          filterBy="name,code"
          placeholder="Select a currency"
          class="w-full"
          appendTo="body"
        />
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium" for="currency-exchange-rate"
          >Exchange rate</label
        >
        <p class="m-0 text-xs text-surface-switch-500">
          1 {{ baseCurrencyCode() }} =
        </p>
        <p-inputNumber
          inputId="currency-exchange-rate"
          [ngModel]="exchangeRate()"
          (ngModelChange)="exchangeRate.set($event)"
          [min]="0.000001"
          [minFractionDigits]="0"
          [maxFractionDigits]="6"
          [useGrouping]="false"
          class="w-full"
          inputStyleClass="w-full"
        />
        @if (selectedCurrency(); as selected) {
          <p class="m-0 text-xs text-surface-switch-500">
            {{ selected.code }}
          </p>
        }
        @if ((selectedCurrency()?.exchange_rate ?? null) != exchangeRate()) {
          <p class="m-0 text-xs text-surface-switch-500">
            The current suggested exchange rate is
            {{ selectedCurrency()?.exchange_rate }}
          </p>
        }
      </div>

      @if (saveError()) {
        <p class="m-0 text-sm text-red-600" role="alert">{{ saveError() }}</p>
      }
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        label="Cancel"
        severity="secondary"
        [text]="true"
        [disabled]="isSaving()"
        (onClick)="close()"
      />
      <p-button
        label="Save"
        [disabled]="!canSave"
        [loading]="isSaving()"
        (onClick)="save()"
      />
    </div>
  </ng-template>
</p-dialog>
